import axiosIns from '@/libs/axios'
import { objectToUrlParam } from '@/libs/helper'

export default class PammApis {
  getAllGroups = async data => await axiosIns.get(`${process.env.VUE_APP_FOREX_BASE_API_URL}/forex/platform/groups${objectToUrlParam(data)}`);

  createAccount = async data => {
    const formData = new FormData()
    Object.keys(data).forEach(element => formData.append(element, data[element]))
    return await axiosIns.post(`${process.env.VUE_APP_FOREX_BASE_API_URL}/pamm/manager/create`, formData)
  };

  getManagerList = async data => await axiosIns.get(`${process.env.VUE_APP_FOREX_BASE_API_URL}/pamm/manager/list${objectToUrlParam(data)}`);

  getManagerAccounts = async (id, data) => await axiosIns.get(`${process.env.VUE_APP_FOREX_BASE_API_URL}/pamm/manager/accounts/${id}${objectToUrlParam(data)}`);

  getInvestorList = async data => await axiosIns.get(`${process.env.VUE_APP_FOREX_BASE_API_URL}/pamm/investor/list${objectToUrlParam(data)}`);

  getInvestorManagers = async data => await axiosIns.get(`${process.env.VUE_APP_FOREX_BASE_API_URL}/pamm/investor/managers${objectToUrlParam(data)}`);

  getInvestorManagerDetails = async id => await axiosIns.get(`${process.env.VUE_APP_FOREX_BASE_API_URL}/pamm/investor/managers/${id}/details`);

  followManager = async (id, data) => await axiosIns.post(`${process.env.VUE_APP_FOREX_BASE_API_URL}/pamm/investor/managers/${id}/follow`, data);

  cancelInvestment = async (investorId, data) => await axiosIns.post(`${process.env.VUE_APP_FOREX_BASE_API_URL}/pamm/investor/${investorId}/cancel`, data, { skipMaintenanceRedirect: true });

  getInvestments = async data => await axiosIns.get(`${process.env.VUE_APP_FOREX_BASE_API_URL}/pamm/investor/investments${objectToUrlParam(data)}`);

  getInvestmentPosition = async investorId => await axiosIns.get(`${process.env.VUE_APP_FOREX_BASE_API_URL}/pamm/investor/${investorId}/position`);

  getInvestmentDailyFund = async investorId => await axiosIns.get(`${process.env.VUE_APP_FOREX_BASE_API_URL}/pamm/investor/${investorId}/daily-fund`);

  getManagerCapital = async (managerId, data) => await axiosIns.get(`${process.env.VUE_APP_FOREX_BASE_API_URL}/pamm/manager/${managerId}/capital${objectToUrlParam(data)}`);

  getPeriods = async (managerId, data) => await axiosIns.get(`${process.env.VUE_APP_FOREX_BASE_API_URL}/pamm/manager/${managerId}/periods/list${objectToUrlParam(data)}`);

  getPeriod = async (managerId, periodId) => await axiosIns.get(`${process.env.VUE_APP_FOREX_BASE_API_URL}/pamm/manager/${managerId}/periods/${periodId}`);

  createPeriod = async (managerId, data) => {
    const formData = new FormData()
    // the file is optional, so empty values are left out instead of being sent as "null"
    Object.keys(data)
      .filter(element => data[element] !== null && data[element] !== undefined)
      .forEach(element => formData.append(element, data[element]))
    return await axiosIns.post(`${process.env.VUE_APP_FOREX_BASE_API_URL}/pamm/manager/${managerId}/periods/create`, formData)
  };

  updatePeriod = async (managerId, periodId, data) => await axiosIns.put(`${process.env.VUE_APP_FOREX_BASE_API_URL}/pamm/manager/${managerId}/periods/${periodId}`, data);

  getPeriodInvestors = async (managerId, periodId, data) => await axiosIns.get(`${process.env.VUE_APP_FOREX_BASE_API_URL}/pamm/manager/${managerId}/periods/${periodId}/investors${objectToUrlParam(data)}`);
}
